import { OPENAI_PIXEL_ID } from './marketingPixelConfig.js';

/**
 * @param {{ eventId?: string }} [options]
 */
export function trackOpenAiRegistrationCompleted(options = {}) {
  if (typeof window === 'undefined' || !OPENAI_PIXEL_ID) {
    return;
  }

  const oaiq = window.oaiq;
  if (typeof oaiq !== 'function') {
    return;
  }

  const eventId = String(options.eventId || '').trim();
  const measureOptions = eventId ? { event_id: eventId } : undefined;

  oaiq(
    'measure',
    'registration_completed',
    {
      type: 'customer_action',
    },
    measureOptions
  );
}
